export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const SET_MITRA_ITEMS = 'SET_MITRA_ITEMS';
export const SET_MITRA_ITEM_TRANSACTION = 'SET_MITRA_ITEM_TRANSACTION';
